var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebForms01 = function SvgWebForms01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "web_forms-01_svg2__a",
    x1: 3.63,
    x2: 152.71,
    y1: 160.2,
    y2: 4.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__b",
    x1: 18.13,
    x2: 167.21,
    y1: 174.07,
    y2: 18.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__c",
    x1: 32.64,
    x2: 181.72,
    y1: 187.94,
    y2: 32.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__d",
    x1: 41.25,
    x2: 190.33,
    y1: 196.18,
    y2: 40.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__e",
    x1: -22.47,
    x2: 126.61,
    y1: 135.23,
    y2: -20.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__f",
    x1: -7.97,
    x2: 141.11,
    y1: 149.1,
    y2: -6.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__g",
    x1: 6.53,
    x2: 155.61,
    y1: 162.97,
    y2: 7.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__h",
    x1: 21.03,
    x2: 170.11,
    y1: 176.84,
    y2: 20.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__i",
    x1: 83.26,
    x2: 232.35,
    y1: 236.37,
    y2: 80.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#web_forms-01_svg2__a",
    id: "web_forms-01_svg2__j",
    x1: 19.06,
    x2: 168.14,
    y1: 174.95,
    y2: 19.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 67.74h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      fill: "url(#web_forms-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 96.77h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      fill: "url(#web_forms-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52 125.8h61.29c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23",
    style: {
      fill: "url(#web_forms-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23 148.38H64.52c-1.78 0-3.23 1.44-3.23 3.23s1.44 3.23 3.23 3.23h38.71c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23",
    style: {
      fill: "url(#web_forms-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 54.84h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      fill: "url(#web_forms-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 83.87h-12.9c-1.78 0-3.23 1.44-3.23 3.23V100c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23V87.1c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      fill: "url(#web_forms-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 112.89h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.91h-6.45v-6.45h6.45z",
    style: {
      fill: "url(#web_forms-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61 141.93h-12.9c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h12.9c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23m-3.22 12.9h-6.45v-6.45h6.45z",
    style: {
      fill: "url(#web_forms-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7 149.4a3.224 3.224 0 0 0-4.56-.08l-20.3 20.3L144.22 159a3.22 3.22 0 0 0-4.48 0 3.224 3.224 0 0 0-.08 4.56l12.9 12.9c.6.6 1.43.94 2.28.95.86 0 1.68-.34 2.28-.95l22.58-22.58a3.22 3.22 0 0 0 0-4.48",
    style: {
      fill: "url(#web_forms-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.29 129.18V45.16c0-.17-.02-.34-.04-.51 0-.04 0-.08-.02-.11 0-.05-.02-.1-.04-.14-.01-.05-.02-.11-.04-.16a.5.5 0 0 0-.04-.11c-.02-.06-.04-.13-.07-.19a.3.3 0 0 0-.04-.08c-.03-.07-.06-.14-.1-.21-.01-.02-.03-.05-.04-.07-.04-.07-.08-.13-.12-.2-.02-.04-.05-.07-.08-.1-.04-.05-.07-.1-.11-.15-.07-.08-.14-.16-.22-.24L118.41.95c-.6-.6-1.43-.94-2.28-.95H9.68C7.9 0 6.45 1.44 6.45 3.23v193.54c0 1.78 1.44 3.23 3.23 3.23h148.38c19.59-.02 35.46-15.9 35.48-35.48 0-18.51-14.17-33.71-32.26-35.34ZM119.36 11.01l30.92 30.92h-30.92zM12.9 193.54V6.45h99.99v38.71c0 1.78 1.44 3.23 3.23 3.23h38.71v80.79c-18.09 1.63-32.26 16.83-32.26 35.34 0 12 5.96 22.61 15.08 29.03H12.9Zm145.16 0c-16.03 0-29.03-13-29.03-29.03s13-29.03 29.03-29.03c16.03.02 29.01 13.01 29.03 29.03 0 16.03-13 29.03-29.03 29.03",
    style: {
      fill: "url(#web_forms-01_svg2__j)"
    }
  }));
};
export default SvgWebForms01;